import React, { useEffect } from "react";
import { DateRange } from "../../utils/dateRange";
import CustomDateRange from "../custom-date-range";
import Form from "../form";
import { DateRangeWrapper } from "./styles";
import useDateRanges, { RangeKey } from "./useDateRange";

export type DateRangeDropDownProps = {
  handleDateRangeChange: (currentRange: DateRange) => void;
  initialRangeKey: RangeKey;
};
export const DateRangeDropDown: React.FC<DateRangeDropDownProps> = ({
  handleDateRangeChange,
  initialRangeKey,
}) => {
  const { currentRange, ...dateRange } = useDateRanges(
    initialRangeKey ?? "12m"
  );

  useEffect(() => {
    handleDateRangeChange(currentRange);
  }, [currentRange, handleDateRangeChange]);

  return (
    <DateRangeWrapper>
      <Form.Dropdown
        options={Object.values(dateRange.options)}
        value={dateRange.options[dateRange.activeRangeKey]}
        onChange={dateRange.rangeKeyUpdateHandler}
        mapper={(s) => s}
      />
      {dateRange.isCustom && (
        <CustomDateRange
          onInputChange={dateRange.handleCustomDateRangeChange}
        />
      )}
    </DateRangeWrapper>
  );
};
